import { Page } from '@/core/architecture'

import { ReplyDetailTemplate } from './template'
import { useViewModel } from './viewModel'

export const ReplyDetail: Page = () => {
  const { state, actions } = useViewModel()

  return <ReplyDetailTemplate state={state} {...actions} />
}
